import React, { PropTypes, Component } from 'react'
import SwipeableViews from 'react-swipeable-views';
import Slideshow from 'react-icons/lib/md/slideshow';
import withMedia from '../../../containers/withmedia';
import withPager from '../../../lib/pager';
import ImageViewer from '../imageviewer';
import { toggleOverlay } from '../../../store/reducers';
import {connect} from 'react-redux';
import style from './style.css';

class PhotoBanner extends Component {

    constructor(props){
        super(props)
        this.state = { current_photo: 0, lightbox: false }
        this._current_photo = this._current_photo.bind(this)
        this._open_lightbox = this._open_lightbox.bind(this)
        this._close_lightbox = this._close_lightbox.bind(this)
        this._handle_click_image = this._handle_click_image.bind(this)
        this.slides_count = null
        
    }
    componentWillReceiveProps(nextProps) {
        const { pager, room } = this.props
        if(room && pager && pager.setCount && this.slides_count===null){
            this.slides_count = this.count();
            pager.setCount(this.slides_count) 
        }
    }

    _close_overlay(){
        this._close_lightbox();
        this.props._toggle_overlay(false);
    }

    _current_photo(idx, idxlatest){
        const { pager } = this.props
        if('goto' in pager) { pager.goto(idx) }
    }
    _close_lightbox(){
        this.setState({...this.state, lightbox: false })
    }

    _open_lightbox(){
        this.setState({...this.state, lightbox: true })
        this.props._toggle_overlay(true);
    }
    count(){
        const { page } = this.props
        const gallery_size =  page ? page.frames.length : 0
        return gallery_size
    }
    _handle_click_image () {
        // console.log("Handle click photo")
        const { page } = this.props
        if (this.state.current_photo === page.frames.length - 1) return;
        this._go_to_next();
    }

    _ligthbox(){
        const { page } = this.props
        const domain = "https://www.sunrise-resorts.com"
        const image_set = page && page.frames && page.frames.map((node) => {
            return {   
                src: `${domain}${node.photo.photo_uri.replace("medium","large")}`,
                srcset: [
                        `${domain}${node.photo.photo_uri.replace("medium","gallery")} 1024w`,
                        `${domain}${node.photo.photo_uri.replace("medium","gallery")} 800w`,
                        `${domain}${node.photo.photo_uri} 500w`,
                        `${domain}${node.photo.photo_uri.replace("medium","large")} 320w`
                    ]
                }
            }
        )
        return image_set
    }

    render() {
        const { page, pager, current, css } = this.props
        const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
        const photos_count = page && page.frames ? page.frames.length : null
        const image_set = page ? this._ligthbox() : null
        const is_large = this.props.browser && this.props.browser.greaterThan.small

        return (
            <div>
                <div className={ style.photoBanner }>
                    <div className={ style.fade }></div>
                    <SwipeableViews className={ style.slider } onChangeIndex={ (idx, latest) => this._current_photo(idx, latest) }>
                        { page && page.frames && page.frames.map( (node) => 
                        <div className={ style.img } style={{ backgroundImage: `url('https://www.sunrise-resorts.com${ node && node.photo && node.photo.photo_uri.replace("medium", is_large ? "gallery" : "large") }')`, }}></div>
                        )}
                    </SwipeableViews>
                    <div className={ `${style.dotnav} ${css && css.dotnav}` } >
                        { image_set && image_set.map( ( e , i ) => 
                        <div className={ i== current ? style.activeDot : style.inactiveDot }></div>
                    )
                        }
                    </div>
                    <Slideshow className={ style.slideshow } onClick={() => this._open_lightbox() }/>
                </div>
                {image_set && this.state.lightbox && pager && 
                <ImageViewer 
                    close={ this._close_overlay.bind(this) } 
                    previous={ pager.previous } 
                    next={ pager.next } 
                    photo={ () => { console.log("getting current photo " + current ); return image_set[current] } } 
                    count={ this.count() } 
                    current={ current } />
                }
            </div>
        )
    }
}

export default withMedia(withPager(connect( 
    state =>({
        overlay: state.app.overlay
    }),
    dispatch => { 
    return { 
        _toggle_overlay: (payload) => { dispatch(toggleOverlay(payload)) } ,
    } 
    }
)(PhotoBanner)))



// WEBPACK FOOTER //
// ./src/components/pagescreen/photobanner/index.js